'use client';

import { useQuery, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from '../constants.ts';
import { PrimedSupporterData, SupporterQueryPart } from '../queries.ts';

type SupporterDataStatus = PrimedSupporterData['dataStatus'];

export const getSupporterDataIssues = (
  dataStatus: SupporterDataStatus | undefined,
  keys?: SupporterQueryPart[],
) => {
  if (!dataStatus?.isPartial || !dataStatus.issues?.length) {
    return [];
  }

  if (!keys?.length) {
    return dataStatus.issues;
  }

  return dataStatus.issues.filter((issue) =>
    keys.includes(issue.key as SupporterQueryPart),
  );
};

export const hasSupporterDataIssues = (
  dataStatus: SupporterDataStatus | undefined,
  keys?: SupporterQueryPart[],
) => {
  return getSupporterDataIssues(dataStatus, keys).length > 0;
};

export const useSupporterDataStatus = () => {
  const queryClient = useQueryClient();

  return useQuery<PrimedSupporterData['dataStatus'] | undefined>({
    queryKey: [QUERY_KEYS.supporterDataStatus],
    queryFn: ({ queryKey }) =>
      queryClient.getQueryData<PrimedSupporterData['dataStatus']>(queryKey),
    enabled: false,
  });
};
